// Names are E2E-encrypted, so member search runs client-side on decrypted fields.
// Case-insensitive substring match on name OR headline.
export const normalize = (s) => (s || "").toString().normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

export const matchesMember = (m, query) => {
  const q = normalize(query);
  if (!q) return true;
  return normalize(m?.name).includes(q) || normalize(m?.headline).includes(q);
};
